import { FilterOrderOptions } from '@lib/services/base/filter';
import { usePaginate } from '@lib/services/base/paginate';
import { BlueprintData, GameConfig } from '@lib/services/models';

import client from '../client';

export type GameConfigByEnv = {
  listBlueprintVersionDto: BlueprintData[];
  listGameConfigDto: GameConfig[];
};

export const paging = (param: any) => client.api.gameConfigControllerList({ ...param, take: 1000 });

export const getAll = () => {
  return client.api.gameConfigControllerGetAll();
};

export const upsert = (gameConfig: GameConfig) => {
  return client.api.gameConfigControllerUpsert(gameConfig);
};

export const useGetGameConfigList = (order?: FilterOrderOptions) => {
  return usePaginate<GameConfig>('/api/game-config', { order });
};

export const forceUpdate = (gameConfig: GameConfig) => {
  return client.api.gameConfigControllerForceUpdate(gameConfig.id?.toString() as string);
};

export const unforceUpdate = (gameConfig: GameConfig) => {
  return client.api.gameConfigControllerUnforceUpdate(gameConfig.id?.toString() as string);
};

export const deleteById = (id: any) => {
  return client.api.gameConfigControllerDeleteById(id as any);
};
